<div *ngIf="data; else noData" class="row-table">
  <div class="row table-title">
    <div class="col-2" i18n="@@front.affiliateProgram.rewards.level">Level</div>
    <div class="col-4" i18n="@@front.affiliateProgram.rewards.depositRange">Deposit & Buy Range</div>
    <div class="col-3" i18n="@@front.affiliateProgram.rewards.youGet">You Get</div>
    <div class="col-3" i18n="@@front.affiliateProgram.rewards.theyGet">They Get</div>
  </div>
  <div *ngFor="let item of data" class="row table-item">
    <div class="col-2" i18n="@@front.affiliateProgram.rewards.levelValue">Level {{item?.level}}</div>
    <div class="col-4">{{item?.amountFrom?.amount | number:'0.0'}}{{item?.amountTo ? ' -' : '+'}} {{item?.amountTo?.amount | number:'0.0'}} {{item?.amountFrom?.currency}}</div>
    <div class="col-3">{{item?.reward?.amount | number:'0.0'}} {{item?.reward?.currency}}</div>
    <div class="col-3">{{item?.reward?.amount | number:'0.0'}} {{item?.reward?.currency}}</div>
  </div>
</div>

<ng-template #noData>
  <p class="text-center" i18n="@@front.affiliateProgram.rewards.loading">Loading reward structure</p>
</ng-template>